import { combineReducers } from 'redux';
import maps from './maps';
import main from './main';

export default combineReducers({ main, maps });
